import {Injectable} from '@angular/core';
import {Alarm} from '../model/alarm.model';
import {retryAfterMillis} from '../shared/constants';
import {ApiService} from './api.service';
import {isEmpty, utf8Decode} from 'sdv-common';

@Injectable({providedIn: 'root'})
export class AlarmService {

  private alarms: Alarm[] = [];

  constructor(private apiService: ApiService) {
    this.load();
  }

  load() {
    this.apiService.get('alarms')
      .subscribe(response => {
        const alarms: Alarm[] = [];
        for (const alarm of response) {
          alarms.push(this.covertAlarm(alarm));
        }
        this.alarms = alarms;
      }, err => {
        this.apiService.error({}, err);
        setTimeout(() => this.load(), retryAfterMillis);
      });
  }

  private covertAlarm(alarm) {
    return {
      type: alarm.typeId || 0,
      id: utf8Decode(alarm.id || ''),
      code: utf8Decode(alarm.code || ''),
      locales: (alarm.locales || []).map(locale => {
        return {
          id: utf8Decode(locale.id || ''),
          text: utf8Decode(locale.text || ''),
          title: utf8Decode(locale.title || '')
        };
      })
    };
  }

  list(limit, offset) {
    return this.alarms;
  }

  get(id) {
    for (const alarm of this.alarms) {
      if (alarm.id === id) {
        return alarm;
      }
    }
    return {
      id: id,
      type: 1,
      code: id,
      locales: [{
        title: id,
        text: id
      }]
    };
  }

  create($e, alarm) {
    const locales: any[] = Object.values(alarm.locales);

    this.apiService.post('alarms', {
      code: alarm.code,
      typeId: alarm.type,
      attrs: alarm.attrs
        .filter(attr => !isEmpty(attr.value))
        .map(attr => ({
          typeId: attr.id,
          value: attr.value
        })),
      locales: Object.values(locales)
        .filter(locale => !isEmpty(locale.text) && !isEmpty(locale.title))
        .map(locale => ({
          languageId: locale.languageId,
          levelId: locale.levelId,
          title: locale.title,
          text: locale.text
        }))
    }).subscribe(alarm => {
      this.alarms.push(this.covertAlarm(alarm));
      $e.target.parentNode.querySelector('[data-bs-dismiss]')
        .dispatchEvent(new Event('click'));
    }, err => {
      this.apiService.error(alarm, err);
    });
  }
}
